import React, { useEffect, useId, useRef, useState } from "react";
import {
  APP_STORE_QR_SRC,
  APP_STORE_URL,
  isMobileDownloadClient,
} from "../config/appStore";
import "./DownloadAppCta.css";

/**
 * Smart download CTA: App Store on phones, QR popover on desktop/tablet.
 */
const DownloadAppCta = ({
  className = "",
  children = "Download the app",
  ...rest
}) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const titleId = useId();

  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    const onPointerDown = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    window.addEventListener("keydown", onKeyDown);
    document.addEventListener("pointerdown", onPointerDown);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("pointerdown", onPointerDown);
    };
  }, [open]);

  const onClick = (event) => {
    event.preventDefault();
    if (isMobileDownloadClient()) {
      window.location.assign(APP_STORE_URL);
      return;
    }
    setOpen((prev) => !prev);
  };

  return (
    <span className="download-app-cta" ref={rootRef}>
      <button
        type="button"
        className={className}
        onClick={onClick}
        aria-expanded={open}
        aria-haspopup="dialog"
        {...rest}
      >
        {children}
      </button>
      {open ? (
        <div
          className="download-app-popover"
          role="dialog"
          aria-modal="false"
          aria-labelledby={titleId}
        >
          <img
            className="download-app-popover__qr"
            src={APP_STORE_QR_SRC}
            alt="QR code to download InvestX on the App Store"
            width={160}
            height={160}
          />
          <p id={titleId} className="download-app-popover__title">
            Scan to download InvestX
          </p>
          <a
            className="download-app-popover__link"
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {APP_STORE_URL}
          </a>
        </div>
      ) : null}
    </span>
  );
};

export default DownloadAppCta;
